















































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { EAdminTaskStatus, ETrainingMilestoneStatus, IAdminTask, ITrainingMilestone } from '@zunta/configurations'
import Icon from '@/components/Icon.vue'
import { UserModule } from '@/store/modules/user.module'
import TrainingSettingsModal from './TrainingSettingsModal.vue'
import Accordion from '@/components/Accordion.vue'
import { mileStoneDescriptionActions } from '../../milestones/helpers/milestone'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { MilestoneTemplate, MilestoneDescriptions } from '@/store/types/milestone'

@Component({
    components: {
        Card,
        Checkbox,
        Icon,
        TrainingSettingsModal,
        Accordion,
        DateTimeLabel
    },
    props: {
        subTemplates: {
            type: Array,
            required: true
        },
        milestone: {
            type: Object,
            required: true
        },
        groupedMilestones: {
            type: Array,
            required: true

        },
        parentId: {
            type: Number,
            required: true
        }
    },
    methods: {
        mileStoneDescriptionActions
    }
})
export default class TrainingDetailsMilestone extends Vue {
    userModuleInstance: UserModule = getModule(UserModule, this.$store);
    ETrainingMilestoneStatus: any = ETrainingMilestoneStatus;
    promises: Promise<void>[] = []
    milestone = this.$props.milestone
    mileStoneDescriptionActions = mileStoneDescriptionActions
    descriptionsOfMilestones: MilestoneDescriptions[] = this.$props.subTemplates.map((subTemplate: MilestoneTemplate) => {
        return {
            id: subTemplate.id,
            show: false,
            description: subTemplate.description
        }
    })
    get tasks () {
        return this.$store.state.chain.adminTasks.filter((adminTask: IAdminTask) => adminTask.status === EAdminTaskStatus.TODO)
    }

    get milestoneDescription () {
        return this.milestone.template.description
    }

    changeStatus (milestone: ITrainingMilestone, event: boolean, parentId: number) {
        this.$emit('updateMilestone',
            { milestone: milestone.id, event, parentId }
        )
    }
}
